export default __webpack_public_path__ + "static/media/firstPic.982573af.webp";